// src/App.jsx
import { Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";

/* —— 页面 —— */
import Home from "./pages/Home"; // Eager load to avoid initial Suspense blank on root
const HomeV3            = lazy(() => import("./pages/HomeV3"));
const HomeV4            = lazy(() => import("./pages/HomeV4"));
const Count             = lazy(() => import("./pages/Count"));
const Login             = lazy(() => import("./pages/Login"));
const ResetPassword     = lazy(() => import("./pages/ResetPassword"));
const Programs          = lazy(() => import("./pages/Programs"));
const PdfFrame          = lazy(() => import("./pages/PdfFrame"));
const About             = lazy(() => import("./pages/About"));
const AboutLia          = lazy(() => import("./pages/AboutLia"));
const JoinUs            = lazy(() => import("./pages/JoinUs"));
const College_Acceptance = lazy(() => import("./pages/College_Acceptance"));
const MeetOurTeachers   = lazy(() => import("./pages/MeetOurTeachers"));
const SAT_PSAT          = lazy(() => import("./pages/SAT_PSAT"));
const PlacementTest     = lazy(() => import("./pages/placementTest"));
const SAT_PSAT_results  = lazy(() => import("./pages/SAT_PSAT_results"));
import ProtectedRoute  from "./ProtectedRoute";
const Admin             = lazy(() => import("./pages/Admin"));
const ParentHub         = lazy(() => import("./pages/ParentHub"));
const Teacher           = lazy(() => import("./pages/Teacher"));
const CourseDetail      = lazy(() => import("./pages/CourseDetail"));
const StudentCourses    = lazy(() => import("./pages/StudentCourses"));


export default function App() {
  return (
    <Suspense fallback={<div style={{padding: 24}}>Loading...</div>}> 
    <Routes>
      {/* —— 公共页面 —— */}
      <Route path="/"          element={<Home />} />
      <Route path="/login"     element={<Login />} />
      <Route path="/homev3"    element={<HomeV3 />} />
      <Route path="/homev4"    element={<HomeV4 />} />
      <Route path="/count"     element={<Count />} />
      <Route path="/reset"     element={<ResetPassword />} />
      <Route path="/programs"  element={<Programs />} />
      <Route path="/pdf-frame" element={<PdfFrame />} />
      {import.meta.env && import.meta.env.DEV ? (
        <>
          <Route path="/programs/:fileName" element={<PdfFrame />} />
          <Route path="/sat-psat/:fileName" element={<PdfFrame />} />
          <Route path="/join/:fileName" element={<PdfFrame />} />
        </>
      ) : null}
      <Route path="/about"     element={<About />} />
      <Route path="/about-lia" element={<AboutLia />} />
      <Route path="/meet-our-teachers" element={<MeetOurTeachers />} />
      <Route path="/join"      element={<JoinUs />} />
      {/* Removed JoinPdfViewer route; join PDFs open directly via Storage URLs */}
      <Route path="/placementTest" element={<PlacementTest />} />
      <Route path="/sat-psat-results" element={<SAT_PSAT_results />} />

      {/* 兼容旧路径，同时提供新规范路径 */}
      <Route path="/results"             element={<College_Acceptance />} />
      <Route path="/result"              element={<College_Acceptance />} />
      <Route path="/college_Acceptance"  element={<College_Acceptance />} />
      <Route path="/sat-psat"  element={<SAT_PSAT />} />
      {/* Removed SatPdfViewer route; SAT/PSAT PDFs open directly via URLs */}

      {/* —— Admin —— */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute requiredRole="admin">
            <Admin />
          </ProtectedRoute>
        }
      />

      {/* —— Parent —— */}
      <Route
        path="/parent"
        element={
          <ProtectedRoute requiredRole="parent">
            <ParentHub />
          </ProtectedRoute>
        }
      />

      {/* —— Teacher —— */}
      <Route
        path="/teacher"
        element={
          <ProtectedRoute requiredRole="teacher">
            <Teacher />
          </ProtectedRoute>
        }
      />

      {/* —— Course Detail —— */}
      <Route
        path="/course/:id"
        element={
          <ProtectedRoute requiredRole="admin">
            <CourseDetail />
          </ProtectedRoute>
        }
      />

      {/* —— Student Courses —— */}
      <Route
        path="/student/:sid"
        element={
          <ProtectedRoute requiredRole="admin">
            <StudentCourses />
          </ProtectedRoute>
        }
      />
    </Routes>
    </Suspense>
  );
}
